import { Component, HostListener } from '@angular/core';
import { environment } from '../../../environments/environment';
import {BsModalRef} from "ngx-bootstrap/modal";
import {ApiService} from "../../services/api.service";
import {AppMessage} from "../../app.message";
import {SucursalDTO} from "../../../dtos/sucursal.dto";
import {GetListaSucursalesResponseDTO} from "../../../dtos/response/getListaSucursales.response.dto";
import {SucursalService} from "../../services/sucursal.service";
import {NgForOf, NgIf} from "@angular/common";
import {NgSelectModule} from "@ng-select/ng-select";
import { ToastrService } from 'ngx-toastr';
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-cambiar-sucursal',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    NgSelectModule,
  ],
  templateUrl: './cambiar-sucursal.component.html',
  styleUrl: './cambiar-sucursal.component.scss'
})
export class CambiarSucursalComponent {

  public listaSucursales: Array<SucursalDTO> = [];
  public sucursalesSeleccionada: Array<SucursalDTO> = [];
  public forzado: boolean = false;
  public todosMarcado: boolean = false;

  constructor(private modalRef: BsModalRef, private apiService: ApiService,
              private sucursalService: SucursalService,
              private toastr: ToastrService) {

    this.todosMarcado = this.sucursalService.isTodasSeleccionadas();
    this.sucursalesSeleccionada = this.sucursalService.getSucursalesSeleccionadas();
    this.getListaSucursales();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    if (this.forzado) return;
    this.close();
  }

  close() {
    if (this.forzado) return;
    this.modalRef.hide();
  }

  getListaSucursales() {
    this.apiService.getListaSucursales().subscribe((resp) => this.getListaSucursalesSuccess(resp), (error) => this.getListaSucursalesError(error));
  }

  getListaSucursalesSuccess(getListaSucursalesResponseDTO: GetListaSucursalesResponseDTO) {
    console.log('exito get sucursales', getListaSucursalesResponseDTO);
    this.listaSucursales = getListaSucursalesResponseDTO.data;
    if (this.todosMarcado) return;
    this.sucursalesSeleccionada.forEach((sucursal) => {
      for(let sucursalTmp of this.listaSucursales) {
        if(sucursal.uuid == sucursalTmp.uuid) {
          sucursalTmp.seleccionada = true;
          break;
        }
      }
    })
  }

  getListaSucursalesError(error: HttpErrorResponse) {
    console.log('error get sucursales', error);
    const msg = error.error.msg ? error.error.msg : AppMessage.ERROR_GET_LISTA_SUCURSALES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  marcarSeleccion(event: any, sucursal: SucursalDTO) {
    sucursal.seleccionada = event.target.checked;
    if (event.target.checked && this.todosMarcado) {
      this.todosMarcado = false;
    }
  }

  getSucursalesSeleccionadasTmpComoTexto() {
    if (this.todosMarcado) return 'TODAS';
    return this.listaSucursales.filter(sucursal => sucursal.seleccionada).map(sucursal => sucursal.nombre).join(', ');
  }

  marcarTodas(event: any) {
    this.todosMarcado = event.target.checked;
    this.listaSucursales.forEach(sucursal => sucursal.seleccionada = false);
  }

  cambiarSucursal() {
    if (this.todosMarcado) {
      this.sucursalService.setSucursalesSeleccionadas(this.listaSucursales, true);
      this.modalRef.hide();
      return;
    }
    const sucursalesSeleccionadas = this.listaSucursales.filter(sucursal => sucursal.seleccionada);
    if(sucursalesSeleccionadas.length == 0) {
      this.toastr.warning('Debe seleccionar al menos una sucursal', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }
    this.sucursalService.setSucursalesSeleccionadas(sucursalesSeleccionadas, false);
    this.modalRef.hide();
  }




}
